import {Box, Divider, Typography} from "@mui/material"

type DiscountSummaryProps = {
	balanceInCents: number
	discountRate: number | ""
	variant?: "oneOff" | "plan"
}

const variantStyles = {
	oneOff: {backgroundColor: "#F2F9FE", border: "1px solid #D5D7DA"},
	plan: {backgroundColor: "#F9F9FE", border: "1px solid #91A2F3"},
}

function DiscountSummary({balanceInCents, discountRate, variant = "oneOff"}: DiscountSummaryProps) {
	const safeBalance = Math.max(0, balanceInCents)
	const safeDiscount = typeof discountRate === "number" ? Math.min(100, Math.max(0, discountRate)) : 0
	const balance = safeBalance / 100
	const discountAmount = (balance * safeDiscount) / 100
	const finalAmount = balance - discountAmount

	const fmt = (value: number) => `$${value.toFixed(2)}`

	return (
		<Box
			sx={{
				...variantStyles[variant],
				borderRadius: "4px",
				p: "0.75rem",
				display: "flex",
				flexDirection: "column",
				gap: "0.5rem",
			}}
		>
			<Box sx={{display: "flex", justifyContent: "space-between"}}>
				<Typography sx={{fontSize: "0.75rem", color: "rgba(0,0,0,0.6)"}}>Current full balance:</Typography>
				<Typography sx={{fontSize: "0.75rem", color: "rgba(0,0,0,0.6)", textDecoration: "line-through"}}>
					{fmt(balance)}
				</Typography>
			</Box>
			<Box sx={{display: "flex", justifyContent: "space-between"}}>
				<Typography sx={{fontSize: "0.75rem", color: "rgba(0,0,0,0.6)"}}>
					Discount amount ({safeDiscount}%):
				</Typography>
				<Typography sx={{fontSize: "0.75rem", color: "rgba(0,0,0,0.6)"}}>-{fmt(discountAmount)}</Typography>
			</Box>
			<Divider />
			<Box sx={{display: "flex", justifyContent: "space-between"}}>
				<Typography sx={{fontSize: "0.75rem", color: "rgba(0,0,0,0.6)"}}>Final amount to pay:</Typography>
				<Typography sx={{fontSize: "0.75rem", color: "rgba(0,0,0,0.6)", fontWeight: 700}}>
					{fmt(finalAmount)}
				</Typography>
			</Box>
		</Box>
	)
}

export {DiscountSummary}
